import { inject, Injectable } from '@angular/core';
import { ClientBaseApi } from '../clientBase.api';
import { Observable } from 'rxjs';
import { User } from '../../auth/auth.service';
import { ConfigService } from '../../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class UsersService extends ClientBaseApi {
  private readonly config = inject(ConfigService);

  private readonly gatewayURL = this.config.getConfig('gatewayUrl')!;

  public getUser(id: string): Observable<User> {
    return this.getData(`${this.gatewayURL}api/users/${id}`);
  }
}
